import type { RoundStats } from '../types';

export const pct = (part: number, total: number | null | undefined): number | null =>
  total && total > 0 ? Math.round((part / total) * 1000) / 10 : null;

/** Voters enabled who did not vote (they count as blank with the "habilitados" base) */
export const nonVoters = (r: RoundStats): number => Math.max((r.eligible ?? 0) - r.votes_cast, 0);

export function formatDuration(seconds: number | null): string {
  if (seconds === null) return '—';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m >= 60 ? `${Math.floor(m / 60)} h ${m % 60} min` : m > 0 ? `${m} min ${s} s` : `${s} s`;
}

/** Fill the minutes without votes, so a pause shows as a gap in the chart */
export function fillMinutes(points: { t: string; n: number }[]): { t: number; n: number }[] {
  if (points.length === 0) return [];
  const parsed = points.map((p) => ({ t: new Date(p.t).getTime(), n: p.n })).sort((a, b) => a.t - b.t);
  const byMinute = new Map(parsed.map((p) => [p.t, p.n]));
  const out: { t: number; n: number }[] = [];
  for (let t = parsed[0].t; t <= parsed[parsed.length - 1].t; t += 60_000) out.push({ t, n: byMinute.get(t) ?? 0 });
  return out;
}
